export default "__VITE_ASSET__FmlzF8a9__"